function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#9e9e9e",
  d: "M13 6.133A10.683 10.683 0 0 1 22.622 12 10.683 10.683 0 0 1 13 17.867 10.683 10.683 0 0 1 3.378 12 10.683 10.683 0 0 1 13 6.133M13 4a12.9 12.9 0 0 0-12 8 12.9 12.9 0 0 0 12 8 12.9 12.9 0 0 0 12-8 12.9 12.9 0 0 0-12-8zm0 5.333A2.667 2.667 0 1 1 10.273 12 2.7 2.7 0 0 1 13 9.333M13 7.2A4.863 4.863 0 0 0 8.091 12a4.91 4.91 0 0 0 9.818 0A4.863 4.863 0 0 0 13 7.2z",
  transform: "translate(-1 -4)"
});

function SvgIconEyeOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOn);
export default __webpack_public_path__ + "static/media/icon-eye-on.c7637400.svg";
export { ForwardRef as ReactComponent };